/**
 * Treat "abort" as a non-error.
 *
 * We intentionally avoid surfacing aborted requests in the UI since they are
 * expected during rapid interactions (tab switch, filter/search changes) and
 * in React StrictMode mount/unmount cycles.
 */
export default function isAbortError(error: unknown): boolean {
  if (!error) {
    return false;
  }

  // DOM abort (fetch/AbortController). Guard for non-browser environments.
  if (
    typeof DOMException !== 'undefined' &&
    error instanceof DOMException &&
    error.name === 'AbortError'
  ) {
    return true;
  }

  // RTK Query abort / wrapped errors
  if (typeof error === 'object') {
    const name =
      'name' in error ? String((error as { name?: unknown }).name) : '';
    const message =
      'message' in error
        ? String((error as { message?: unknown }).message)
        : '';

    if (name === 'AbortError') {
      return true;
    }

    const msg = message.toLowerCase();

    return msg.includes('aborted') || msg.includes('aborterror');
  }

  return false;
}
